// src/components/Layout/AppLayout.jsx
import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useAuth } from "../providers/AuthProvider";
import NotificationBanner from "../features/notifications/NotificationBanner";
import TopNav from "./TopNav";
import SideNav from "./SideNav";

function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      sessionStorage.removeItem("beSession");
      sessionStorage.removeItem("fromModulePicker");
      await logout?.();
    } finally {
      navigate("/login", { replace: true });
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", width: "100%" }}>
      {/* SIDE NAV */}
      <SideNav
        currentPath={location.pathname}
        onNavigate={(path) => navigate(path)}
      />

      {/* MAIN COLUMN */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        }}
      >
        {/* TOP NAV */}
        <TopNav
          user={user}
          onLogout={handleLogout}
          onNavigate={(path) => navigate(path)}
        />

        <NotificationBanner onNavigate={(path) => navigate(path)} />

        {/* MAIN CONTENT */}
        <Box
          component="main"
          sx={{
            flex: 1,
            pt: 8,
            width: "100%",
            boxSizing: "border-box",
            minWidth: 0,
            background: `
              linear-gradient(
                180deg,
                rgba(112,138,48,0.08) 0%,
                rgba(100,131,21,0.04) 45%,
                rgba(100,131,21,0.02) 100%
              ),
              #fafbf8
            `,
          }}
        >
          {/* 🔑 CRITICAL FIX */}
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default AppLayout;
